import { Firestore } from '@angular/fire/firestore';

import { Scope } from '@yoimo/client-sdk/channels';
import {
  getLinkCardItemsFromSource,
  LinkCardSourceQueryOption,
} from '@yoimo/client-sdk/link-card-list';
import { LinkListModule, LinkListItem, Channel } from '@yoimo/interfaces';
import { LinkCardListItem } from '@yoimo/joymo-ui';

import { Observable, map, of } from 'rxjs';

export function getResolvedLinkListItems$(
  fs: Firestore,
  moduleData: LinkListModule,
  scope: Scope,
  channel: Channel,
  homepageUrl: string
): Observable<LinkCardListItem[]> {
  if (scope.scope !== 'CHANNEL') {
    return of([]);
  }
  const options: LinkCardSourceQueryOption = {
    scope: 'CHANNEL',
    scopeId: scope.channel.docId,
  };
  return getLinkCardItemsFromSource(
    fs,
    moduleData.source,
    options,
    channel
  ).pipe(
    map((items) =>
      items.map((item) => getItem(item, homepageUrl)).filter(isDefined)
    )
  );
}

function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export function getLink(item: LinkListItem, homepageUrl = ''): string {
  const base = item.external
    ? `${window.location.origin}${homepageUrl}`
    : homepageUrl;

  if ('link' in item) return item.link;
  if ('pageId' in item) return `${base}/pages/${item.pageId}`;
  if ('eventId' in item) return `${base}/events/${item.eventId}`;

  return '';
}

export function getItem(
  item: LinkListItem,
  homepageUrl: string
): LinkCardListItem {
  console.debug(item.external, getLink(item, homepageUrl));

  return {
    title: item.title || '',
    image: item.image || '',
    link: getLink(item, homepageUrl),
    external: item.external || false,
  };
}
